/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Lesrooster_OngeldigInputs */

const nl_planning_api_errors_lesrooster_ongeldig = /** @type {(inputs: Planning_Api_Errors_Lesrooster_OngeldigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De lesuren en pauzes van deze dag overlappen elkaar.`)
};

/**

* @param {Planning_Api_Errors_Lesrooster_OngeldigInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_lesrooster_ongeldig = /** @type {((inputs?: Planning_Api_Errors_Lesrooster_OngeldigInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Lesrooster_OngeldigInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_lesrooster_ongeldig(inputs)
});
export { planning_api_errors_lesrooster_ongeldig as "planning.api_errors.lesrooster_ongeldig" }